import { BadgeVariant } from 'src/components/Badge';
import { PostCallAnalysisResultItemStatus } from 'src/interfaces/agent.interface';

export const statusToBadgeVariant = (
  status: PostCallAnalysisResultItemStatus,
): BadgeVariant => {
  switch (status) {
    case PostCallAnalysisResultItemStatus.EXTRACTED:
      return 'success';
    case PostCallAnalysisResultItemStatus.COULD_NOT_DETERMINE:
      return 'secondary';
    default:
      return 'secondary';
  }
};

export const statusToLabel = (
  status: PostCallAnalysisResultItemStatus,
): string => {
  switch (status) {
    case PostCallAnalysisResultItemStatus.EXTRACTED:
      return 'Extracted';
    case PostCallAnalysisResultItemStatus.COULD_NOT_DETERMINE:
      return 'Could not determine';
    default:
      return 'Could not determine';
  }
};

export const formatValue = (value: unknown): string => {
  if (value === null || value === undefined) return '-';
  if (typeof value === 'boolean') return value ? 'Yes' : 'No';
  if (typeof value === 'number') return value.toString();
  if (typeof value === 'string') return value;

  try {
    return JSON.stringify(value);
  } catch {
    return String(value);
  }
};
